// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mr20{margin-right:1.042vw}.small{font-size:.833vw}", ""]);
// Exports
module.exports = exports;
